export const PUBLIC_WEBSITE_ORIGIN = "https://www.rubbl.com";

/** Dev and local renders must remain excluded even after page-specific SEO runs. */
export function websiteRobots(requested: string, clientId: string, production: string, hostname: string): string {
  if (clientId === "rubbl.website" &&
      (production !== "true" || !["www.rubbl.com", "rubbl.com"].includes(hostname))) {
    return /\bnofollow\b/i.test(requested) ? "noindex, nofollow" : "noindex, follow";
  }
  return requested;
}

export function marketplaceTypePlural(type: string): string {
  return /s$/i.test(type) ? type : `${type}s`;
}
